<template>
  <div class="ai-container">
    <!-- Catalogue -->
    <exlcomponent></exlcomponent>
  </div>
</template>

<script>
import exlcomponent from "@/views/documentation/index.vue";
import $ from "jquery";
import "jquery.terminal";
import "jquery.terminal/css/jquery.terminal.min.css"; // 确保引入 CSS
export default {
  name: "CatalogueComponent",
  components: {
    exlcomponent,
  },
  data() {
    return {
      GitIsTrue: false,
    };
  },
  methods: {
    open() {
      try {
        let d = document.getElementsByClassName("file-show-type");
        console.log(d);
        d[1].style.display = "block";
      } catch (error) {}
    },
  },
  mounted() {},
  computed: {},
};
</script>

<style scoped>
.ai-container {
  width: 100%;
  position: fixed;
  height: 100%;
}
</style>
